import axios from '@/utils/request'
import base from '../base'
import Qs from 'qs'

export default {
  header() {
    const headers = {
      "isAjax": 'true',
      'Content-Type': 'application/json'
    }
    return headers
  },
  /*查询聊天页面配置列表*/
  queryConChatPageList(data) {
    return axios.post(`${base.url_im}/serviceBusiness/conChatPage/queryConChatPageList`, data, { headers: this.header()})
  },
  /*新增聊天页面配置*/
  addConChatPage(data){
    return axios.post(`${base.url_im}/serviceBusiness/conChatPage/addConChatPage`, data, { headers: this.header()})
  },
  /*根据id更新聊天页面配置*/
  updateConChatPage(data){
    return axios.post(`${base.url_im}/serviceBusiness/conChatPage/updateConChatPage`, data, { headers: this.header()})
  },
  /*查询最大排序列*/
  queryMaxSortRow(data){
    return axios.post(`${base.url_im}/serviceBusiness/conWelcomeMessage/queryMaxSortRow`, Qs.stringify(data))
  },
  /*分页查询客户端欢迎语列表*/
  queryConWelcomeMessageListPage(data){
    return axios.post(`${base.url_im}/serviceBusiness/conWelcomeMessage/queryConWelcomeMessageListPage`, data, { headers: this.header()})
  },
  /*新增客户端欢迎语*/
  addConWelcomeMessage(data){
    return axios.post(`${base.url_im}/serviceBusiness/conWelcomeMessage/addConWelcomeMessage`, data, { headers: this.header()})
  },
  /*根据id更新客户端欢迎语*/
  updateConWelcomeMessage(data){
    return axios.post(`${base.url_im}/serviceBusiness/conWelcomeMessage/updateConWelcomeMessage`, data, { headers: this.header()})
  },
  /*根据id删除客户端欢迎语*/
  deleteConWelcomeMessage(data){
    return axios.post(`${base.url_im}/serviceBusiness/conWelcomeMessage/deleteConWelcomeMessage`, Qs.stringify(data))
  },
  /*根据ids批量删除客户端欢迎语*/
  deleteBatchConWelcomeMessage(data){
    return axios.post(`${base.url_im}/serviceBusiness/conWelcomeMessage/deleteBatchConWelcomeMessage`, Qs.stringify(data))
  },
  /*查询客服常用语树形*/
  queryConCommonMessageVoTree(data){
    return axios.post(`${base.url_im}/serviceBusiness/conCommonMessage/queryConCommonMessageVoTree`, data, { headers: this.header()})
  },
  /*查询客服常用语全部树形*/
  queryConCommonMessageVoTrees(data){
    return axios.post(`${base.url_im}/serviceBusiness/conCommonMessage/queryConCommonMessageVoTrees`, data, { headers: this.header()})
  },
  /*分页查询客服常用语树形*/
  queryConCommonMessageVoTreePage(data){
    return axios.post(`${base.url_im}/serviceBusiness/conCommonMessage/queryConCommonMessageVoTreePage`, data, { headers: this.header()})
  },
  /*分页刷选公共常用语树数据*/
  searchConCommonMessageListPage(data){
    return axios.post(`${base.url_im}/serviceBusiness/conCommonMessage/searchConCommonMessageListPage`, data, { headers: this.header()})
  },
  /*根据id递归删除客服常用语*/
  deleteRecursiveConCommonMessage(data){
    return axios.post(`${base.url_im}/serviceBusiness/conCommonMessage/deleteRecursiveConCommonMessage`, Qs.stringify(data))
  },
  /*根据ids批量递归删除客服常用语*/
  deleteBatchRecursiveConCommonMessage(data){
    return axios.post(`${base.url_im}/serviceBusiness/conCommonMessage/deleteBatchRecursiveConCommonMessage`, Qs.stringify(data))
  },
  /*查询客服常用语列表*/
  queryConCommonMessageList(data){
    return axios.post(`${base.url_im}/serviceBusiness/conCommonMessage/queryConCommonMessageList`, data, { headers: this.header()})
  },
  /*新增客服常用语目录*/
  addConCommonDirectory(data){
    return axios.post(`${base.url_im}/serviceBusiness/conCommonMessage/addConCommonDirectory`, data, { headers: this.header()})
  },
  /*新增客服常用语*/
  addConCommonMessage(data){
    return axios.post(`${base.url_im}/serviceBusiness/conCommonMessage/addConCommonMessage`, data, { headers: this.header()})
  },
  /*根据id更新客服常用语*/
  updateConCommonMessage(data){
    return axios.post(`${base.url_im}/serviceBusiness/conCommonMessage/updateConCommonMessage`, data, { headers: this.header()})
  },
  /*查询客服资源列表*/
  queryConCommonResourceList(data){
    return axios.post(`${base.url_im}/serviceBusiness/conCommonResource/queryConCommonResourceList`, data, { headers: this.header()})
  },
  /*分页查询客服资源列表*/
  queryConCommonResourceListPage(data){
    return axios.post(`${base.url_im}/serviceBusiness/conCommonResource/queryConCommonResourceListPage`, data, { headers: this.header()})
  },
  /*新增客服资源*/
  addConCommonResource(data){
    return axios.post(`${base.url_im}/serviceBusiness/conCommonResource/addConCommonResource`, data, { headers: this.header()})
  },
  /*根据id更新客服资源*/
  updateConCommonResource(data){
    return axios.post(`${base.url_im}/serviceBusiness/conCommonResource/updateConCommonResource`, data, { headers: this.header()})
  },
  /*根据id删除客服资源*/
  deleteConCommonResource(data){
    return axios.post(`${base.url_im}/serviceBusiness/conCommonResource/deleteConCommonResource`, Qs.stringify(data))
  },
  /*根据ids批量删除客服资源*/
  deleteBatchConCommonResource(data){
    return axios.post(`${base.url_im}/serviceBusiness/conCommonResource/deleteBatchConCommonResource`, Qs.stringify(data))
  },
  /*查询客户端会话属性*/
  queryConAccessDictList(data){
    return axios.post(`${base.url_im}/serviceBusiness/conAccessDict/queryConAccessDictList`, data, { headers: this.header()})
  },
  /*分页查询客户端会话属性列表*/
  queryConAccessDictListPage(data){
    return axios.post(`${base.url_im}/serviceBusiness/conAccessDict/queryConAccessDictListPage`, data, { headers: this.header()})
  },
  /*新增客户端会话属性*/
  addConAccessDict(data){
    return axios.post(`${base.url_im}/serviceBusiness/conAccessDict/addConAccessDict`, data, { headers: this.header()})
  },
  /*根据id更新客户端会话属性*/
  updateConAccessDict(data){
    return axios.post(`${base.url_im}/serviceBusiness/conAccessDict/updateConAccessDict`, data, { headers: this.header()})
  },
  /*根据id删除客户端会话属性*/
  deleteConAccessDict(data){
    return axios.post(`${base.url_im}/serviceBusiness/conAccessDict/deleteConAccessDict`, Qs.stringify(data))
  },
  /*根据ids批量删除客户端会话属性*/
  deleteBatchConAccessDict(data){
    return axios.post(`${base.url_im}/serviceBusiness/conAccessDict/deleteBatchConAccessDict`, Qs.stringify(data))
  },
  /*分页查询访客限制列表*/
  queryConAccessLimitListPage(data){
    return axios.post(`${base.url_im}/serviceBusiness/conAccessLimit/queryConAccessLimitListPage`, data, { headers: this.header()})
  },
  /*新增访客限制*/
  addConAccessLimit(data){
    return axios.post(`${base.url_im}/serviceBusiness/conAccessLimit/addConAccessLimit`, data, { headers: this.header()})
  },
  /*根据id更新访客限制*/
  updateConAccessLimit(data){
    return axios.post(`${base.url_im}/serviceBusiness/conAccessLimit/updateConAccessLimit`, data, { headers: this.header()})
  },
  /*根据id删除访客限制*/
  deleteConAccessLimit(data){
    return axios.post(`${base.url_im}/serviceBusiness/conAccessLimit/deleteConAccessLimit`, Qs.stringify(data))
  },
  /*根据ids批量删除访客限制*/
  deleteBatchConAccessLimit(data){
    return axios.post(`${base.url_im}/serviceBusiness/conAccessLimit/deleteBatchConAccessLimit`, Qs.stringify(data))
  },
  /*查询会话调度配置*/
  queryConDistributeRuleVo(data){
    return axios.post(`${base.url_im}/serviceBusiness/conDistributeRule/queryConDistributeRuleVo`, data, { headers: this.header()})
  },
  /*新增会话调度配置*/
  addConDistributeRule(data){
    return axios.post(`${base.url_im}/serviceBusiness/conDistributeRule/addConDistributeRule`, data, { headers: this.header()})
  },
  /*根据id更新会话调度配置*/
  updateConDistributeRule(data){
    return axios.post(`${base.url_im}/serviceBusiness/conDistributeRule/updateConDistributeRule`, data, { headers: this.header()})
  },
  /*用户列表*/
  userList(data) {
    return axios.post(`${base.url_im}/auth/user/list`,data, { headers: this.header() })
  },
  /*修改角色*/
  editUser(data) {
    return axios.post(`${base.url_im}/auth/user/edit`, data, { headers: this.header() })
  },
  /*删除用户*/
  delUser(data) {
    return axios.get(`${base.url_im}/auth/user/del?` + Qs.stringify(data))
  },
  /*获取公司语言*/
  getCompanyLanguage(data) {
    return axios.get(`${base.url_im}/auth/company/getCompanyLanguage?` + Qs.stringify(data))
  },
  /*查询客户端留言配置*/
  queryConLeaveFormList(data) {
    return axios.post(`${base.url_im}/serviceBusiness/conLeaveForm/queryConLeaveFormList`, data, { headers: this.header() })
  },
  /*批量新增客户端留言配置*/
  addBatchConLeaveForm(data) {
    return axios.post(`${base.url_im}/serviceBusiness/conLeaveForm/addBatchConLeaveForm`, data, { headers: this.header() })
  },
  /*根据id批量更新客户端留言配置*/
  updateBatchConLeaveForm(data) {
    return axios.post(`${base.url_im}/serviceBusiness/conLeaveForm/updateBatchConLeaveForm`, data, { headers: this.header() })
  },
  /*查询客户端留言提示列表*/
  queryConLeavePromptList(data) {
    return axios.post(`${base.url_im}/serviceBusiness/conLeavePrompt/queryConLeavePromptList`, data, { headers: this.header() })
  },
  /*新增客户端留言提示*/
  addConLeavePrompt(data) {
    return axios.post(`${base.url_im}/serviceBusiness/conLeavePrompt/addConLeavePrompt`, data, { headers: this.header() })
  },
  /*根据id更新客户端留言提示*/
  updateConLeavePrompt(data){
    return axios.post(`${base.url_im}/serviceBusiness/conLeavePrompt/updateConLeavePrompt`, data, { headers: this.header()})
  },
}
